<template>
    <section class="c-case-banner">
        <y-loading
            v-if="!content"
            :active="true"
            size="60"
            height="100%"
            position="relative"
        />
        <div
            v-else
            class="c-case-banner--loaded"
        >
            <div class="c-case-banner__title">
                <h4>
                    {{ content.custom?.field1 }}
                </h4>
            </div>
            <div class="c-case-banner__description">
                <p class="mb-3">
                    {{ content.custom?.field2 }}
                </p>
            </div>
            <div class="c-case-banner__actions">
                <div class="banner-btn-solid">
                    <y-button
                        color="primary"
                        :tag="isLink(content.custom['field4']) ? 'a' : 'router-link'"
                        :to="content.custom['field4']"
                        :href="content.custom['field4']"
                        :content="content.custom['field3']"
                        size="medium"
                        flat
                        :no-padding="true"
                    />
                </div>
                <div class="banner-btn-border">
                    <y-button
                        color="transparent"
                        :tag="isLink(content.custom['field6']) ? 'a' : 'router-link'"
                        :to="content.custom['field6']"
                        :href="content.custom['field6']"
                        size="medium"
                        flat
                        :no-padding="true"
                        :content="content.custom['field5']"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { isLink } from '@/helpers/helpers';

    export default {
        name : 'CaseStudyBanner',
        props: {
            content: Object,
        },
        methods: {
            isLink,
        },
    };
</script>

<style lang="scss" src="./banner.scss"></style>
